import { useRef } from 'react';
import { useWheelNavigation } from '../hooks/useWheelNavigation';
import { useStore } from '../store/useStore';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../db/db';

export const EmployeeListView = ({ handleItemSelect, selectedIndex, setSelectedIndex }: any) => {
  const scrollRef = useRef(null);
  const activeCompany = useStore((state) => state.activeCompany);
  
  const employees = useLiveQuery(() => 
    activeCompany ? db.employees.where('companyId').equals(activeCompany.id!).toArray() : []
  , [activeCompany]);

  const flatItems = employees || [];
  useWheelNavigation(scrollRef, flatItems.length, setSelectedIndex, false, () => flatItems && flatItems[selectedIndex] && handleItemSelect(flatItems[selectedIndex], selectedIndex));

  return (
    <div className="flex flex-col w-full h-full bg-white z-20 absolute inset-0 font-sans text-[12px] text-black">
      <div className="bg-[#1e8585] text-white flex justify-between px-2 py-[2px] font-bold shadow-sm z-10 text-[13px]">
        <span className="w-1/3 text-left">Employee List</span>
        <span className="w-1/3 text-center uppercase">{activeCompany?.name}</span>
        <span className="w-1/3 text-right cursor-pointer hover:text-gray-300" onClick={() => handleItemSelect({ name: 'Quit' })}>✕</span>
      </div>

      <div className="flex border-b border-gray-300 px-2 py-1 font-bold items-center text-black shadow-sm z-10 bg-gray-50">
        <div className="w-[100px]">Emp ID</div>
        <div className="flex-1">Employee Name</div>
        <div className="w-[150px]">Department</div>
        <div className="w-[150px]">Designation</div>
        <div className="w-[100px] text-right">Net Salary</div>
        <div className="w-[80px] text-center">Status</div>
      </div>

      <div ref={scrollRef} className="flex-1 overflow-y-auto px-1 py-1 scrollbar-thin">
         {flatItems.length === 0 ? (
           <div className="p-4 text-center text-gray-400 italic">No employees found. Create one from Master Creation.</div>
         ) : (
           flatItems.map((emp: any, idx: number) => {
              const isSelected = selectedIndex === idx;
              const netSalary = emp.salaryStructure.basic + emp.salaryStructure.hra + emp.salaryStructure.conveyance + emp.salaryStructure.otherAllowances - emp.salaryStructure.pfDeduction - emp.salaryStructure.esiDeduction - emp.salaryStructure.tdsDeduction;
              
              return (
                 <div 
                   key={emp.id} 
                   onClick={() => handleItemSelect({ ...emp, level: 'alter_employee_form' }, idx)} 
                   className={`flex px-1 py-[4px] cursor-pointer border-b border-gray-100 items-center ${isSelected ? 'bg-[#1e8585] text-white font-bold active-row' : 'text-black'}`}
                 >
                    <div className="w-[100px]">{emp.employeeId}</div>
                    <div className="flex-1">{emp.name}</div>
                    <div className="w-[150px]">{emp.department}</div>
                    <div className="w-[150px]">{emp.designation}</div>
                    <div className="w-[100px] text-right">₹ {netSalary.toFixed(2)}</div>
                    <div className="w-[80px] text-center">
                      <span className={`px-1 rounded text-[10px] ${emp.status === 'Active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                        {emp.status}
                      </span>
                    </div>
                 </div>
              );
           })
         )}
      </div>

      <div className="bg-[#f1f5f9] border-t border-gray-300 px-4 py-1 text-[11px] flex justify-between text-gray-500">
          <span>Total Employees: {flatItems.length}</span>
          <span>Press Enter to Alter / Edit Employee</span>
      </div>
    </div>
  );
};
